<template>
  <div id="app">
    <top-navbar v-if="user"></top-navbar>
    <router-view></router-view>
  </div>
</template>

<script>
import TopNavbar from "./components/TopNavbar.vue";
export default {
  name: "app",

  components: {
    TopNavbar
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  }
};
</script>

<style >
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
